import { render } from "./zzsdzptfplkys.vue?vue&type=template&id=b4125282&scoped=true"
import script from "./zzsdzptfplkys.vue?vue&type=script&lang=js"
export * from "./zzsdzptfplkys.vue?vue&type=script&lang=js"

import "./zzsdzptfplkys.vue?vue&type=style&index=0&id=b4125282&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4125282"]])

export default __exports__